export default "__VITE_ASSET__s0gx4j_4__"